import { SystemMessageResolverBase } from './system-message.resolver.base';
import { SystemMessageService } from './system-message.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class SystemMessageResolver extends SystemMessageResolverBase {

  constructor(protected service: SystemMessageService) {
    super(service);
  }
}



